module.exports = __webpack_public_path__ + "static/media/estat_camadas_por_database.20984474.png";